import { useCallback, useEffect, useRef, useState } from "react";

import { timer } from "@vahak/core/dist/methods/timer";

const DEFAULT_RESEND_SECONDS = 30;

/** Countdown for OTP resend with safe restart — clears any active interval before starting a new one. */
export function useResendOtpTimer(durationSeconds = DEFAULT_RESEND_SECONDS) {
    const [timeRemaining, setTimeRemaining] = useState(durationSeconds);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
    const durationRef = useRef(durationSeconds);
    durationRef.current = durationSeconds;

    const clearCountdown = useCallback(() => {
        if (intervalRef.current != null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);

    const restartCountdown = useCallback(() => {
        clearCountdown();
        setTimeRemaining(durationRef.current);
        intervalRef.current = timer(durationRef.current, setTimeRemaining);
    }, [clearCountdown]);

    useEffect(() => {
        restartCountdown();
        return clearCountdown;
    }, [restartCountdown, clearCountdown]);

    return { timeRemaining, restartCountdown, isCountdownActive: timeRemaining > 0 };
}
